<template>
    <nav v-if="pageCount > 1" class="pagination is-centered" role="navigation" aria-label="paginação">
        <a :disabled="page == 1" class="pagination-previous" @click="$emit('update:page', 1)">
            &lt;&lt;
        </a>
        <a :disabled="page == pageCount" class="pagination-next" @click="$emit('update:page', pageCount)">
            &gt;&gt;
        </a>

        <ul class="pagination-list">
            <li>
                <a :disabled="page == 1" class="pagination-link" @click="$emit('update:page', page - 1)">
                    &lt;
                </a>
            </li>
            <li>
                <span>
                    Página <b>{{ page }}</b> de <b>{{ pageCount }}</b>
                </span>
            </li>
            <li>
                <a :disabled="page == pageCount" class="pagination-link" @click="$emit('update:page', page + 1)">
                    &gt;
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
        props: {
            page: {
                type: Number,
                default: 1
            },
            pageCount: {
                type: Number,
                default: 1
            }
        }
    }
</script>